import React, { useState } from "react";
import { Box, Button, Flex, Text, useDisclosure } from "@chakra-ui/react";
import TableLog, { DeleteByDate } from "./tableLog";
import toast from "react-hot-toast";
import { actionHistoryCall } from "../../api/logs";
import { useActionHistory } from "../../hooks/useLog";
import { customDateFormatType, formatDate } from "../../utils/utils";
import DeleteDialog from "../../components/dialog/delete";

export default function Logs() {
   const {
    isOpen,
    onOpen,
    onClose,
  } = useDisclosure();
  const {
    isOpen: isOpenDelete,
    onOpen: onOpenDelete,
    onClose: onCloseDelete,
  } = useDisclosure();
  const [startTime, setStartTime] = useState(null);
  const [endTime, setEndTime] = useState(null);
  const [deleteAction, setDeleteAction] = useState(false);

  const { refetch, isRefetching } = useActionHistory();

  const onSubmitDelete = async (startTime, endTime) => {
    const toastEdit = toast.loading("Đang xóa dữ liệu ...");

    try {
      const data = {};
      if (startTime) data.startTime = customDateFormatType(startTime);
      if (endTime) data.endTime = customDateFormatType(endTime);
      // setCurrentPage(1);
      await actionHistoryCall.deleteByDay(data);
      setDeleteAction(true);
      await refetch();
      toast.success("Xóa dữ liệu liệu thành công");
      onClose();
      onCloseDelete();
    } catch (error) {
      console.error("Error:", error);
      toast.error("Có lỗi xảy ra Xóa dữ liệu liệu");
    }
    toast.dismiss(toastEdit);
  };

  const onSubmitPopup = async (startTime, endTime) => {
    setStartTime(startTime);
    setEndTime(endTime);
    onOpen();
  }

  return (
    <Box
      w={{ base: "100%" }}
      backgroundColor="var(--color-backgroundmain)"
      p={{ base: "24px 16px 16px" }}
    >
      <Flex alignItems={"center"} justifyContent={"space-between"}>
        <Flex alignItems={"center"} gap={{ base: "74px" }}>
          <Text fontSize={{ base: "20px" }} fontWeight={600}>
            Quản lý logs
          </Text>
        </Flex>
        <Button
          w={"176px"}
          h={"44px"}
          display={"flex"}
          alignItems={"center"}
          p={"10px 16px 10px 12px"}
          gap={"8px"}
          background="var(--linear-gradient-employee)"
          _hover={{
            filter: "brightness(90%)",
          }}
          onClick={() => onOpenDelete()}
        >
          <Text
            fontSize={{ base: "15px" }}
            fontWeight={600}
            color="var(--color-main)"
          >
            Xóa dữ liệu
          </Text>
        </Button>
      </Flex>
      <Box mt={{ base: "23px" }}>
        <TableLog isRefetchingWithCreate={isRefetching} deleteAction={deleteAction} setDeleteAction={setDeleteAction} />
      </Box>
      <DeleteByDate
        isOpen={isOpenDelete}
        onClose={onCloseDelete}
        onSubmit={onSubmitPopup}
      />
      <DeleteDialog
        isOpen={isOpen}
        onClose={onClose}
        title="Xóa log"
        description={
          <Flex display={"inline"}>
            "Bạn có chắc chắn muốn xóa log từ ngày{" "}
            <Text fontWeight={"600"} display={"inline"}>
              {startTime ? formatDate(startTime) : ''} đến {endTime ? formatDate(endTime) : 'Hiện tại'}
            </Text>{" "}
            này không?"
          </Flex>
        }
        action={() => onSubmitDelete(startTime, endTime)}
      />
    </Box>
  );
}
